import { SiteLayout } from "../components/site/SiteLayout";
import { SEO } from "../components/site/SEO";
import { SITE } from "../content/site";

export default function Privacy() {
  return (
    <SiteLayout>
      <SEO
        title="Privacy Notice — Fourbees Consultancy"
        description="How Fourbees Consultancy handles personal information submitted through our website contact forms."
        path="/privacy"
      />
      <section className="bg-cream py-24 md:py-32" data-testid="privacy-page">
        <div className="container-prose">
          <div className="section-number mb-3">Privacy</div>
          <h1 className="font-heading text-4xl md:text-5xl font-extrabold text-navy leading-tight tracking-tight mb-8">
            Privacy notice.
          </h1>
          <div className="space-y-6 font-body text-base md:text-lg text-charcoal/80 leading-relaxed">
            <p className="text-sm text-charcoal/50 italic">
              Last updated: this notice is a placeholder draft. Please review and confirm the
              wording before publishing — flagged for approval.
            </p>
            <h2 className="font-heading text-2xl font-bold text-navy mt-10 mb-0">Who we are</h2>
            <p>
              {SITE.name} is a UK-based business consultancy based in {SITE.location}.
              You can contact us on{" "}
              <a href={`mailto:${SITE.email}`} className="text-navy underline underline-offset-2">
                {SITE.email}
              </a>{" "}
              or {" "}
              <a href={`tel:${SITE.phone.replace(/\s/g, "")}`} className="text-navy underline underline-offset-2">
                {SITE.phone}
              </a>.
            </p>

            <h2 className="font-heading text-2xl font-bold text-navy mt-10 mb-0">What we collect</h2>
            <p>
              When you submit an enquiry through our website, we collect the information you
              choose to provide — typically your name, business name, email address, telephone
              number (optional), the service you're interested in and the message you send us.
            </p>

            <h2 className="font-heading text-2xl font-bold text-navy mt-10 mb-0">Why we use it</h2>
            <p>
              We use that information only to respond to your enquiry and (if we subsequently
              start working together) to deliver the services we've agreed. We do not sell your
              data or share it with third parties for marketing purposes.
            </p>

            <h2 className="font-heading text-2xl font-bold text-navy mt-10 mb-0">How long we keep it</h2>
            <p>
              Enquiry records are retained for as long as they remain commercially relevant and
              then deleted. You can ask us to delete your record at any time by emailing{" "}
              <a href={`mailto:${SITE.email}`} className="text-navy underline underline-offset-2">
                {SITE.email}
              </a>.
            </p>

            <h2 className="font-heading text-2xl font-bold text-navy mt-10 mb-0">Cookies</h2>
            <p>
              This site uses only essential cookies required for it to run securely (for example,
              remembering that you've dismissed the cookie notice, and keeping admin sessions
              signed in). We don't use advertising or cross-site tracking cookies.
            </p>

            <h2 className="font-heading text-2xl font-bold text-navy mt-10 mb-0">Your rights</h2>
            <p>
              Under UK data protection law you have the right to request a copy of the personal
              data we hold about you, to ask us to correct it, or to ask us to delete it. Please
              email{" "}
              <a href={`mailto:${SITE.email}`} className="text-navy underline underline-offset-2">
                {SITE.email}
              </a>{" "}
              and we'll respond within one month.
            </p>
          </div>
        </div>
      </section>
    </SiteLayout>
  );
}
